import { type MappedNotification, NotificationStatusModel } from 'common/header/notifications/Notifications.types';

export const getNotificationState = (status: MappedNotification['status'] | undefined) => {
  return {
    isReady: status === NotificationStatusModel.FinishedSuccess,
    inProgress: status === NotificationStatusModel.InProgress,
    isQueued: status === NotificationStatusModel.Queued,
    isError: status === NotificationStatusModel.FinishedError,
    isCancelled: status === NotificationStatusModel.Cancelled,
    isRejected: status === NotificationStatusModel.Rejected,
    isUndefined: status === undefined
  };
};
